import { Music2 } from "lucide-react";

export const Cover = ({ src, size, pulse, testid }) => (
  <span className={`grid shrink-0 place-items-center overflow-hidden rounded bg-[#D97706]/15 text-[#F59E0B] ${size} ${pulse && !src ? "animate-pulse" : ""}`} data-testid={testid}>
    {src ? <img src={src} alt="Album cover" className="h-full w-full object-cover animate-in fade-in duration-500" data-testid={`${testid}-img`} /> : <Music2 className="h-1/2 w-1/2" />}
  </span>
);
